// extracted by mini-css-extract-plugin
export default {"nav":"Dslv3EFs8DlEjIz"};